import { schema } from 'normalizr';

const invoiceSchema = new schema.Entity('invoice');

export default invoiceSchema;
